import requests from "./httpService";

const StoreServices = {
  // Store Management
  createStore(franchiseId, storeData) {
    return requests.post(`/api/franchises/${franchiseId}/stores`, storeData);
  },

  getFranchiseStores(franchiseId) {
    return requests.get(`/api/franchises/${franchiseId}/stores`);
  },

  getAllStores() {
    return requests.get("/api/stores/all");
  },

  getStoreByUserId(userId) {
    return requests.get(`/api/stores/user/${userId}`);
  },

  updateStore(storeId, storeData) {
    return requests.put(`/api/stores/${storeId}`, storeData);
  },

  deleteStore(storeId) {
    return requests.delete(`/api/stores/${storeId}`);
  },

  // Store Employees
  createEmployee(storeId, employeeData) {
    return requests.post(`/api/stores/${storeId}/employees`, employeeData);
  },

  getStoreEmployees(storeId) {
    return requests.get(`/api/stores/${storeId}/employees`);
  },

  // Store Services
  createService(storeId, serviceData) {
    return requests.post(`/api/stores/${storeId}/services`, serviceData);
  },

  getStoreServices(storeId) {
    return requests.get(`/api/stores/${storeId}/services`);
  },

  // Store Billings
  createBill(storeId, billingData) {
    return requests.post(`/api/stores/${storeId}/billings`, billingData);
  },

  getStoreBills(storeId) {
    return requests.get(`/api/stores/${storeId}/billings`);
  },

  // Appointments
  createAppointment(storeId, appointmentData) {
    return requests.post(
      `/api/stores/${storeId}/appointments`,
      appointmentData
    );
  },

  getStoreAppointments(storeId, date, status) {
    const query = new URLSearchParams();
    if (date) query.append("date", date);
    if (status) query.append("status", status);
    return requests.get(
      `/api/stores/${storeId}/appointments?${query.toString()}`
    );
  },

  getAppointment(storeId, appointmentId) {
    return requests.get(`/api/stores/${storeId}/appointments/${appointmentId}`);
  },

  updateAppointment(storeId, appointmentId, appointmentData) {
    return requests.put(
      `/api/stores/${storeId}/appointments/${appointmentId}`,
      appointmentData
    );
  },

  deleteAppointment(storeId, appointmentId) {
    return requests.delete(
      `/api/stores/${storeId}/appointments/${appointmentId}`
    );
  },

  // Store Reports
  getDailySalesReport(storeId, date) {
    return requests.get(
      `/api/stores/${storeId}/reports/daily-sales?date=${date}`
    );
  },

  getMonthlySalesReport(storeId, month, year) {
    return requests.get(
      `/api/stores/${storeId}/reports/monthly-sales?month=${month}&year=${year}`
    );
  },

  getEmployeePerformance(storeId) {
    return requests.get(`/api/stores/${storeId}/reports/employee-performance`);
  },

  // Logo Management
  uploadStoreLogo(storeId, logoFile) {
    const formData = new FormData();
    formData.append("logo", logoFile);
    return requests.post(`/api/stores/${storeId}/logo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getStoreLogo(storeId) {
    return requests.get(`/api/stores/${storeId}/logo`);
  },

  updateStoreWithLogo(storeId, storeData, logoFile) {
    const formData = new FormData();

    // Append all store data to FormData
    Object.keys(storeData).forEach((key) => {
      formData.append(key, storeData[key]);
    });

    // Append logo file if provided
    if (logoFile) {
      formData.append("logo", logoFile);
    }

    return requests.put(`/api/stores/${storeId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default StoreServices;
